import { crearPermisos, type PermisoSistema } from './permisos';

const PermisosEmpleado = {
    'listado-empleados': [
        { name: 'ver etiquetas', permission: 'employee.GetTags', microservicio: 'employee' },
        { name: 'ver tabla de empleados', permission: 'employee.GetEmployees', microservicio: 'employee' },
    ],
    'agregar-empleado': [
        { name: 'ver tipo de documentos', permission: 'employee.GetAllDocumentTypes', microservicio: 'employee' },
        { name: 'ver pay rules', permission: 'timekeeper.PayRules', microservicio: 'timekeeper' },
        { name: 'crear empleado', permission: 'employee.CreateEmployee', microservicio: 'employee' },
    ],
    'editar-empleado': [
        { name: 'ver empleado detalle', permission: 'employee.GetEmployee', microservicio: 'employee' },
        { name: 'ver tipo documento', permission: 'employee.GetAllDocumentTypes', microservicio: 'employee' },
        { name: 'ver pay rules', permission: 'timekeeper.PayRules', microservicio: 'timekeeper' },
        { name: 'actualizar empleado', permission: 'employee.UpdateEmployee', microservicio: 'employee' },
    ],
    'asignar-contrato': [
        { name: 'ver hirings del empleado', permission: 'employee.GetHiringRanges', microservicio: 'employee' },
        { name: 'ver subcompanies', permission: 'employee.GetAllSubCompanies', microservicio: 'employee' },
        { name: 'ver areas', permission: 'employee.GetAllArea', microservicio: 'employee' },
        { name: 'ver work positions', permission: 'employee.GetAllWorkPositions', microservicio: 'employee' },
        { name: 'ver orgpaths', permission: 'employee.GetHiringOrgpaths', microservicio: 'employee' },
        { name: 'actualiza rango contrato existente', permission: 'employee.UpdateHiringRange', microservicio: 'employee' },
        { name: 'actualiza nombre contrato existente', permission: 'employee.AssignHiringRange', microservicio: 'employee' },
        { name: 'crea nuevo rango contrato', permission: 'employee.CreateHiringRange', microservicio: 'employee' },
        { name: 'crea nuevo contrato asignando rango', permission: 'employee.CreateHiring', microservicio: 'employee' },
        { name: 'crea puesto de contrato', permission: 'employee.AssignHiringOrgpath', microservicio: 'employee' },
        // { name: 'edita puestos de contratos', permission: 'employee.EditEmployeeOrgpath', microservicio: 'employee' },
    ],
    'asignar-puesto': [
        { name: 'ver árbol organizacional', permission: 'employee.GetOrgpathTree', microservicio: 'employee' },
        { name: 'ver hiring con sus orgpath y workposition', permission: 'employee.GetEmployeeOrgpath', microservicio: 'employee' },
        { name: 'guardar puestos', permission: 'employee.AssignHiringOrgpath', microservicio: 'employee' },
    ],
    'asignar-regla-pago': [
        { name: 'ver pay rules', permission: 'timekeeper.PayRules', microservicio: 'timekeeper' },
        { name: 'ver pay rules del empleado', permission: 'employee.GetAllEmployeeRPayRules', microservicio: 'employee' },
        { name: 'guardar pay rules del empleado', permission: 'employee.UpdateEmployeeRPayRule', microservicio: 'employee' },
    ],
    'asignar-regla-horario': [
        { name: 'ver reglas de horario', permission: 'scheduled.GetRuleset', microservicio: 'scheduled' },
        { name: 'ver reglas de horario empleado', permission: 'scheduled.GetAllRulesetsREmployees', microservicio: 'scheduled' },
        { name: 'asignar regla de horario a empleado', permission: 'scheduled.CreateRulesetsREmployees', microservicio: 'scheduled' },
        { name: 'modificar regla de horario a empleado', permission: 'scheduled.UpdateRulesetsREmployees', microservicio: 'scheduled' },
        { name: 'eliminar regla de horario a empleado', permission: 'scheduled.DeleteRulesetsREmployees', microservicio: 'scheduled' },
    ],
    'regla-acumulacion': [
        { name: 'ver reglas asignadas a empleado', permission: 'timekeeper.GetAllAccrualProfilesEmployee', microservicio: 'timekeeper' },
        { name: 'ver reglas de acumulación', permission: 'timekeeper.GetAllAccrualProfiles', microservicio: 'timekeeper' },
        { name: 'guardar asignación reglas acumulación a empleado', permission: 'timekeeper.CreateAccrualProfiles', microservicio: 'timekeeper' },
    ],
    'asignar-etiqueta': [
        { name: 'ver tags', permission: 'employee.GetTags', microservicio: 'employee' },
        { name: 'ver tag del empleado', permission: 'employee.GetTagsByEmployee', microservicio: 'employee' },
        { name: 'guardar tag del empleado', permission: 'employee.AssignEmployeeToTag', microservicio: 'employee' },
    ],
    'crear-etiqueta': [{ name: 'crear tag', permission: 'employee.CreateTag', microservicio: 'employee' }],
} as const satisfies Record<string, readonly PermisoSistema[]>;

const PermisosSchedule = {
    list_schedules: [
        { name: 'ver etiquetas', permission: 'employee.GetTags', microservicio: 'employee' },
        { name: 'ver empleados', permission: 'employee.GetEmployees', microservicio: 'employee' },
        { name: 'ver codigos de pagos asignados', permission: 'timekeeper.GetPaycodeAssignREmployee', microservicio: 'timekeeper' },
        { name: 'ver codigos de pago tipo duracion', permission: 'timekeeper.GetDurationPaycodeREmployee', microservicio: 'timekeeper' },
        { name: 'ver turnos', permission: 'scheduled.GetShift', microservicio: 'scheduled' },
        { name: 'ver todos los turnos ausentes', permission: 'scheduled.GetAllAbsenceExtendShift', microservicio: 'scheduled' },
    ],
    create_shift: [{ name: 'crear turno', permission: 'scheduled.CreateShift', microservicio: 'scheduled' }],
    submit_create_shift: [
        { name: 'crear turno', permission: 'scheduled.CreateShift', microservicio: 'scheduled' },
        { name: 'actualizar turno', permission: 'scheduled.PatchShift', microservicio: 'scheduled' },
    ],
    update_shift: [{ name: 'actualizar turno', permission: 'scheduled.PatchShift', microservicio: 'scheduled' }],
    delete_shift: [{ name: 'eliminar turno', permission: 'scheduled.DeleteShift', microservicio: 'scheduled' }],
    justify_shift: [
        { name: 'ver codigos de pago', permission: 'timekeeper.Paycodes', microservicio: 'timekeeper' },
        { name: 'justificar turno', permission: 'timekeeper.PaycodeAssignREmploye', microservicio: 'timekeeper' },
    ],
    add_paycode: [
        { name: 'ver codigos de pago', permission: 'timekeeper.Paycodes', microservicio: 'timekeeper' },
        { name: 'agregar codigo de pago', permission: 'timekeeper.PaycodeAssignREmploye', microservicio: 'timekeeper' },
    ],
    update_paycode: [
        { name: 'ver codigo de pago asignado por id', permission: 'timekeeper.GetPaycodeAssignREmployeeById', microservicio: 'timekeeper' },
        { name: 'ver codigos de pago', permission: 'timekeeper.Paycodes', microservicio: 'timekeeper' },
        { name: 'actualizar codigo de pago', permission: 'timekeeper.UpdatePaycodeAssignREmployee', microservicio: 'timekeeper' },
    ],
    delete_paycode: [{ name: 'eliminar codigo de pago', permission: 'timekeeper.DeletePaycodeAssignREmployee', microservicio: 'timekeeper' }],
} as const satisfies Record<string, readonly PermisoSistema[]>;

const PermisosLecturaSchedule = {
    tags: [{ name: 'ver etiquetas', permission: 'employee.GetTags', microservicio: 'employee' }],
    employees: [{ name: 'ver empleados', permission: 'employee.GetEmployees', microservicio: 'employee' }],
    paycode_assigns: [{ name: 'ver codigos de pagos asignados', permission: 'timekeeper.GetPaycodeAssignREmployee', microservicio: 'timekeeper' }],
    duration_paycodes: [{ name: 'ver codigos de pago tipo duracion', permission: 'timekeeper.GetDurationPaycodeREmployee', microservicio: 'timekeeper' }],
    shifts: [{ name: 'ver turnos', permission: 'scheduled.GetShift', microservicio: 'scheduled' }],
    absences: [{ name: 'ver todos los turnos ausentes', permission: 'scheduled.GetAllAbsenceExtendShift', microservicio: 'scheduled' }],
} as const satisfies Record<string, readonly PermisoSistema[]>;

const PermisosReportes = {
    'listado-resultados': [{ name: 'ver resultados de reportes', permission: 'reports.GetExecutions', microservicio: 'reports' }],
    'listar-reportes': [{ name: 'ver reportes', permission: 'reports.GetReports', microservicio: 'reports' }],
    'listar-categorias': [
        { name: 'ver categorías asignadas a la compañía', permission: 'reports.GetCategory', microservicio: 'reports' },
        { name: 'ver categorías de reportes', permission: 'reports.GetCategoryAll', microservicio: 'reports' },
    ],
    'ejecutar-reporte': [{ name: 'ejecutar reportes', permission: 'reports.Execute', microservicio: 'reports' }],
    'eliminar-resultado': [{ name: 'eliminar resultados de reportes', permission: 'reports.DeleteExecution', microservicio: 'reports' }],
    'crear-reporte': [
        { name: 'ver categorías asignadas a la compañía', permission: 'reports.GetCategory', microservicio: 'reports' },
        { name: 'ver categorías de reportes', permission: 'reports.GetCategoryAll', microservicio: 'reports' },
        { name: 'ver reportes', permission: 'reports.GetReports', microservicio: 'reports' },
        { name: 'ver empleados', permission: 'employee.GetEmployees', microservicio: 'employee' },
        { name: 'ver etiquetas', permission: 'employee.GetTags', microservicio: 'employee' },
        { name: 'ejecutar reportes', permission: 'reports.Execute', microservicio: 'reports' },
    ],
} as const satisfies Record<string, readonly PermisoSistema[]>;

type AccionEmpleado = keyof typeof PermisosEmpleado;
type AccionSchedule = keyof typeof PermisosSchedule;
type AccionLecturaSchedule = keyof typeof PermisosLecturaSchedule;
type AccionReportes = keyof typeof PermisosReportes;

const { getPermisos: getPermisosEmpleado, usePermiso: usePermisoEmpleado } = crearPermisos<AccionEmpleado>(PermisosEmpleado);
const { getPermisos: getPermisosSchedule, usePermiso: usePermisoSchedule } = crearPermisos<AccionSchedule>(PermisosSchedule);
const { getPermisos: getPermisosLecturaSchedule, usePermiso: usePermisoLecturaSchedule } = crearPermisos<AccionLecturaSchedule>(PermisosLecturaSchedule);
const { getPermisos: getPermisosReportes, usePermiso: usePermisoReportes } = crearPermisos<AccionReportes>(PermisosReportes);

export {
    PermisosEmpleado,
    PermisosLecturaSchedule,
    PermisosReportes,
    PermisosSchedule,
    getPermisosEmpleado,
    getPermisosLecturaSchedule,
    getPermisosSchedule,
    getPermisosReportes,
    usePermisoEmpleado,
    usePermisoLecturaSchedule,
    usePermisoSchedule,
    usePermisoReportes,
};
export type { AccionEmpleado, AccionLecturaSchedule, AccionReportes, AccionSchedule };
